import { ImageData } from '../models/image/image-data.model';
import { ImageDimensions } from '../models/image/image-dimensions.model';

export abstract class ImageDataDb {
    static card = {
        // Shared card frames. Each consumed slot uses the largest rendered width
        // across card sliders and grids for that size and viewport band.
        small: new ImageData('card_small', [
            new ImageDimensions(344, 258), // < lg
            new ImageDimensions(304, 228), // lg
            new ImageDimensions(272, 204), // xl
            new ImageDimensions(308, 231), // xxl
            new ImageDimensions(308, 231), // unused slot (kept for 5-tuple shape)
        ]),
        medium: new ImageData('card_medium', [
            new ImageDimensions(344, 258), // < lg
            new ImageDimensions(304, 228), // lg
            new ImageDimensions(368, 276), // xl
            new ImageDimensions(416, 312), // xxl
            new ImageDimensions(416, 312), // unused slot (kept for 5-tuple shape)
        ]),
        large: new ImageData('card_large', [
            new ImageDimensions(344, 258), // < lg
            new ImageDimensions(464, 348), // lg
            new ImageDimensions(560, 420), // xl
            new ImageDimensions(632, 474), // xxl
            new ImageDimensions(632, 474), // unused slot (kept for 5-tuple shape)
        ]),
        /** @deprecated Use the size-based card profiles above. */
        product: {
            three: new ImageData('product_3', [
                new ImageDimensions(320, 240), // sm
                new ImageDimensions(320, 240), // md
                new ImageDimensions(320, 240), // lg
                new ImageDimensions(320, 240), // xl
                new ImageDimensions(320, 240), // xxl
            ]),
            fourPlus: new ImageData('product_4+', [
                new ImageDimensions(320, 240),
                new ImageDimensions(320, 240),
                new ImageDimensions(320, 240),
                new ImageDimensions(320, 240),
                new ImageDimensions(320, 240),
            ]),
        },
        /** @deprecated Use the size-based card profiles above. */
        info: {
            slider: {
                three: new ImageData('info_slider_3', [
                    new ImageDimensions(304, 228),
                    new ImageDimensions(304, 228),
                    new ImageDimensions(304, 228),
                    new ImageDimensions(368, 276),
                    new ImageDimensions(416, 312),
                ]),
                fourPlus: new ImageData('info_slider_4+', [
                    new ImageDimensions(304, 228),
                    new ImageDimensions(304, 228),
                    new ImageDimensions(272, 204),
                    new ImageDimensions(272, 204),
                    new ImageDimensions(308, 231),
                ]),
            },
            grid: {
                small: new ImageData('info_grid_small', [
                    new ImageDimensions(344, 258),
                    new ImageDimensions(344, 258),
                    new ImageDimensions(304, 228),
                    new ImageDimensions(272, 204),
                    new ImageDimensions(308, 231),
                ]),
                medium: new ImageData('info_grid_medium', [
                    new ImageDimensions(344, 258),
                    new ImageDimensions(344, 258),
                    new ImageDimensions(304, 228),
                    new ImageDimensions(368, 276),
                    new ImageDimensions(416, 312),
                ]),
                large: new ImageData('info_grid_large', [
                    new ImageDimensions(344, 258),
                    new ImageDimensions(344, 258),
                    new ImageDimensions(464, 348),
                    new ImageDimensions(560, 420),
                    new ImageDimensions(632, 474),
                ]),
            },
        },
    };

    static feature = {
        small: new ImageData('small', [
            new ImageDimensions(735, 413),
            new ImageDimensions(224, 224),
            new ImageDimensions(304, 228),
            new ImageDimensions(368, 276),
            new ImageDimensions(416, 312),
        ]),
        medium: new ImageData('medium', [
            new ImageDimensions(735, 413),
            new ImageDimensions(704, 396),
            new ImageDimensions(544, 408),
            new ImageDimensions(656, 492),
            new ImageDimensions(740, 555),
        ]),
        large: new ImageData('large', [
            new ImageDimensions(735, 413),
            new ImageDimensions(704, 396),
            new ImageDimensions(944, 531),
            new ImageDimensions(1136, 639),
            new ImageDimensions(1280, 720),
        ]),
    };

    static hero = {
        gradient: new ImageData('gradient', [
            new ImageDimensions(734, 734),
            new ImageDimensions(296, 296),
            new ImageDimensions(400, 400),
            new ImageDimensions(480, 480),
            new ImageDimensions(540, 540),
        ]),
        image: new ImageData('image', [
            new ImageDimensions(768, 0),
            new ImageDimensions(1024, 0),
            new ImageDimensions(1280, 0),
            new ImageDimensions(1600, 0),
            new ImageDimensions(1800, 0),
        ]),
    };

    static media = {
        single: new ImageData('single', [
            new ImageDimensions(735, 413),
            new ImageDimensions(704, 396),
            new ImageDimensions(944, 531),
            new ImageDimensions(1136, 639),
            new ImageDimensions(1280, 720),
        ]),
        slider: {
            small: {
                two: new ImageData('slider_small_2', [
                    new ImageDimensions(360, 203),
                    new ImageDimensions(344, 194),
                    new ImageDimensions(464, 261),
                    new ImageDimensions(560, 315),
                    new ImageDimensions(632, 356),
                ]),
                three: new ImageData('slider_small_3', [
                    new ImageDimensions(304, 171),
                    new ImageDimensions(304, 171),
                    new ImageDimensions(304, 171),
                    new ImageDimensions(368, 207),
                    new ImageDimensions(416, 234),
                ]),
                fourPlus: new ImageData('slider_small_4+', [
                    new ImageDimensions(272, 153),
                    new ImageDimensions(272, 153),
                    new ImageDimensions(272, 153),
                    new ImageDimensions(272, 153),
                    new ImageDimensions(308, 174),
                ]),
            },
            big: new ImageData('slider_big', [
                new ImageDimensions(343, 193),
                new ImageDimensions(704, 396),
                new ImageDimensions(944, 531),
                new ImageDimensions(1136, 639),
                new ImageDimensions(1280, 720),
            ]),
        },
        collage: {
            oneOne: new ImageData('collage_1x1', [
                new ImageDimensions(360, 360),
                new ImageDimensions(164, 164),
                new ImageDimensions(224, 224),
                new ImageDimensions(272, 272),
                new ImageDimensions(308, 308),
            ]),
            twoTwo: new ImageData('collage_2x2', [
                new ImageDimensions(735, 735),
                new ImageDimensions(344, 344),
                new ImageDimensions(464, 464),
                new ImageDimensions(560, 560),
                new ImageDimensions(632, 632),
            ]),
            twoOne: new ImageData('collage_2x1', [
                new ImageDimensions(344, 164),
                new ImageDimensions(344, 164),
                new ImageDimensions(464, 224),
                new ImageDimensions(560, 272),
                new ImageDimensions(632, 308),
            ]),
        },
    };

    // v1 passes `autocrop=false`, so these are `fit-in` bounding boxes, not delivered ratios.
    static productHeader = new ImageData('product_header', [
        new ImageDimensions(704, 528), // < lg (1024): mobile + md
        new ImageDimensions(480, 640), // lg
        new ImageDimensions(552, 736), // xl
        new ImageDimensions(636, 848), // xxl
        new ImageDimensions(636, 848), // unused slot (kept for 5-tuple shape)
    ]);

    // Art-directed crops; ADR 0003 derives each figure.
    static productHeaderV2 = {
        main: new ImageData('product_header_v2', [
            new ImageDimensions(736, 552), // 4:3 stacked
            new ImageDimensions(944, 708), // 4:3 stacked
            new ImageDimensions(387, 516), // 3:4 side column
            new ImageDimensions(426, 568), // 3:4 side column
            new ImageDimensions(426, 568), // unused slot (kept for 5-tuple shape)
        ]),
        thumbnail: new ImageData('product_header_v2_thumbnail', [
            new ImageDimensions(80, 80),
            new ImageDimensions(80, 80),
            new ImageDimensions(80, 80),
            new ImageDimensions(80, 80),
            new ImageDimensions(80, 80),
        ]),
    };

    // Bounding boxes, not crops: the explorer stage renders fit-in (no crop) at
    // the image's own aspect ratio, so square boxes sized to the stage track
    // work for any render. Below lg the stage is the full single column; from
    // lg it is the fixed 480px centre track (equal lg/xl/xxl slots collapse
    // into a single <source>).
    static productFeatureExplorer = new ImageData('', [
        new ImageDimensions(768, 768), // < lg: single-column stage
        new ImageDimensions(480, 480), // lg+: fixed centre track
        new ImageDimensions(480, 480),
        new ImageDimensions(480, 480),
        new ImageDimensions(480, 480), // unused slot (kept for 5-tuple shape)
    ]);

    // Product comparer frames are 4:3. Each consumed slot covers the widest
    // supported two-column frame in its viewport band.
    static productInformation = new ImageData('product_information', [
        new ImageDimensions(368, 276), // < lg
        new ImageDimensions(472, 354), // lg
        new ImageDimensions(568, 426), // xl
        new ImageDimensions(640, 480), // xxl
        new ImageDimensions(640, 480), // unused slot (kept for 5-tuple shape)
    ]);

    static quote = new ImageData('', [
        new ImageDimensions(344, 258),
        new ImageDimensions(704, 528),
        new ImageDimensions(352, 264),
        new ImageDimensions(464, 464),
        new ImageDimensions(476, 476),
    ]);

    static avatar = new ImageData('avatar', [
        new ImageDimensions(24, 24),
        new ImageDimensions(32, 32),
        new ImageDimensions(48, 48),
        new ImageDimensions(64, 64),
        new ImageDimensions(148, 148),
    ]);
}
